import type {Step} from "../../components/stepper/Step.ts";
import {useAtomValue} from "jotai";
import {ApiAtom} from "../../common-process/1-metl-connection/MetlConnectionProperties.ts";
import { AnalysisOptionsAtom, areOptionsSet } from "../2-option-selection/AnalysisOptions.ts";
import {ScanWidget} from "./ScanWidget.tsx";
import {ScanAtom} from "./ScanAtom.tsx";

export function useScanStep(): Step {
    const api = useAtomValue(ApiAtom)
    const options = useAtomValue(AnalysisOptionsAtom)
    const scanResult = useAtomValue(ScanAtom)

    return {
        name: "Scan METL",
        isAvailable: api !== undefined && areOptionsSet(options),
        isCompleted: scanResult !== null,
        Widget: ScanWidget
    }
}